module.exports = __webpack_public_path__ + "static/media/p_20_1.87432bda.png";